import React, { useEffect, useState } from "react";
import Header from "../home/header";
import repImage from '../../img/reps.svg';
import { useLocation, useNavigate, useParams } from "react-router";
import UTILS from "../../utils/commons"
import Loading from "../home/Loading";
import { ApiClient } from "../../utils/api-client";
import { AxiosError } from "axios";
import { Eye, EyeOff } from "lucide-react";

const StaffEditForm = ( props ) => {
  let navigate = useNavigate();
  let location = useLocation();
  const loginState = JSON.parse( window.sessionStorage.getItem( "loginState" ) );
  const apiClient = new ApiClient( loginState ? loginState.accessToken : null );
  const [ isLoading, setIsLoading ] = useState( false );
  const { id } = useParams();
  const [ data, setData ] = useState( location.state );
  const [ feedback, setFeedback ] = useState( "" );
  const [ preview, setPreview ] = useState( data?.profileImage || repImage );
  const [ showPassword, setShowPassword ] = useState( false );

  const handleSubmit = ( e ) => {
    e.preventDefault();
    var form = e.target;
    var staff = {};
    staff.firstName = form.fname.value.trim();
    staff.lastName = form.lname.value.trim();
    staff.serviceArea = form.service_area.value.trim();
    staff.phone = form.phone.value.trim();
    staff.email = form.email.value.trim();
    if ( form.password.value && form.password.value.length > 0 ) staff.password = form.password.value;
    staff.profileImage = preview
    saveStaff( staff );
  }
  const uploadImage = ( e ) => {
    try {
      if ( !e || !e.target || !e.target.files || !e.target.files[ 0 ] ) return;
      const file = e.target.files[ 0 ];

      // optional: validate file type (image)
      if ( !file.type || !file.type.startsWith( 'image/' ) ) {
        setFeedback( 'Please select a valid image file' );
        return;
      }
      if ( file.size > UTILS.MAX_FILE_SIZE ) {
        setFeedback( `File size exceeds the maximum limit of ${UTILS.MAX_FILE_SIZE / ( 1024 * 1024 )} MB` );
        return;
      }
      const reader = new FileReader();
      reader.onload = () => {
        // reader.result is a data URL (string)
        setPreview( reader.result );
      };
      reader.onerror = ( err ) => {
        console.error( 'FileReader error:', err );
        setFeedback( 'Failed to read image file' );
        setPreview( repImage );
      };

      reader.readAsDataURL( file );
    } catch ( err ) {
      console.error( err );
      setFeedback( 'Failed to process selected file' );
      setPreview( repImage );
    }

  }
  const handleChange = ( e ) => {
    let target = e.target;
    let value = target.value;
    let nd = data;
    switch ( target.id ) {
      case "fname":
        nd.fname = value;
        break;
      case "lname":
        nd.lname = value;
        break;
      case "email":
        nd.email = value;
        break;
      case "phone":
        nd.phone = value;
        break;
      case "service_area":
        nd.service_area = value;
        break;
      case "password":
        nd.password = value;
        break;
      default:
        break;
    }
    setData( nd );
  }
  const saveStaff = async ( staff ) => {
    setIsLoading( true );
    try {
      await apiClient.patch( `profiles/${id}`, staff );
      navigate( "/staff", { replace: true } );
    }
    catch ( e ) {
      setFeedback( e instanceof AxiosError ? e.response.data.msg : "Oops! Something went wrong" );
    }
    setIsLoading( false );
  }
  const getStaffDetails = async ( mid ) => {
    setIsLoading( true );
    try {
      const response = await apiClient.get( `profiles/${mid}` );
      if ( response.status === 200 ) {
        setData( response.data );
        setPreview( response.data.profileImage || repImage );
      } else {
        setFeedback( "Failed to fetch staff details" );
      }
    }
    catch ( e ) {
      setFeedback( e instanceof AxiosError ? e.response?.data.msg : "Oops! Something went wrong" );
    }
    setIsLoading( false );
  }

  useEffect( () => {
    if ( !data ) getStaffDetails( id );
  }, [] );

  return ( <>
    <Header auth={loginState} />
    <section className="container mx-auto mt-8">
      {feedback.length > 0 ? <div className="w-10/12 md:w-8/12 mx-auto mb-4 rounded-md border border-red-200 bg-red-50 px-3 py-2 text-red-700 text-sm" id="feedback">{feedback}</div> : null}

      <div className="rounded-xl border border-gray-200 bg-white shadow-md p-4 md:p-6">
        <div className="flex items-center justify-between mb-5">
          <div>
            <p className="text-sm uppercase tracking-wide text-gray-500">Staff Setup</p>
            <p className="text-2xl font-semibold text-gray-800">Edit Sales Staff</p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 items-start">
          <div className="md:col-span-1 rounded-xl border border-gray-200 bg-gray-50 p-4 text-center">
            <img id="rep_preview" src={preview} alt="Sales staff feature" className="h-36 w-36 rounded-full object-cover border-2 border-primary-200 mx-auto" />
            <p className="text-sm text-gray-500 mt-3">Profile Preview</p>
          </div>
          <div className="md:col-span-2">
            <form id="edit_staff_form"
              className="w-full"
              method="post" onSubmit={handleSubmit} encType="multipart/form-data"
            >
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                <div className="form-group my-1">
                  <label htmlFor="fname" className="text-sm text-gray-600">First Name</label>
                  <input
                    type="text"
                    className="form-control"
                    id="fname"
                    name="fname"
                    placeholder="First name"
                    defaultValue={data?.auth.firstName} onChange={( e ) => handleChange( e )}
                  />
                </div>
                <div className="form-group my-1">
                  <label htmlFor="lname" className="text-sm text-gray-600">Last Name</label>
                  <input
                    type="text"
                    className="form-control"
                    id="lname"
                    name="lname"
                    placeholder="Last name"
                    defaultValue={data?.auth.lastName} onChange={( e ) => handleChange( e )}
                  />
                </div>
                <div className="form-group my-1 sm:col-span-2">
                  <label htmlFor="profile_image" className="text-sm text-gray-600">Upload Profile Image</label>
                  <input onChange={( e ) => uploadImage( e )}
                    type="file"
                    className="form-control"
                    id="profile_image"
                    name="profile_image"
                  />
                </div>
                <div className="form-group my-1">
                  <label htmlFor="service_area" className="text-sm text-gray-600">Service Area</label>
                  <input
                    type="text"
                    className="form-control"
                    id="service_area"
                    name="service_area"
                    placeholder="Service Area"
                    defaultValue={data.serviceArea} onChange={( e ) => handleChange( e )}
                  />
                </div>
                <div className="form-group my-1">
                  <label htmlFor="phone" className="text-sm text-gray-600">Phone Number</label>
                  <input
                    type="number"
                    className="form-control"
                    id="phone"
                    name="phone"
                    placeholder="Phone Number"
                    defaultValue={data?.phone} onChange={( e ) => handleChange( e )}
                  />
                </div>
                <div className="form-group my-1">
                  <label htmlFor="email" className="text-sm text-gray-600">E-mail</label>
                  <input
                    type="email"
                    className="form-control"
                    id="email"
                    name="email"
                    placeholder="E-mail"
                    defaultValue={data?.auth.email} onChange={( e ) => handleChange( e )}
                  />
                </div>

                <div className="form-group my-1 relative">
                  <label htmlFor="password" className="text-sm text-gray-600">New Password (Optional)</label>
                  <input
                    type={showPassword ? "text" : "password"}
                    className="form-control pr-10"
                    id="password"
                    name="password"
                    placeholder="Password"
                    onChange={( e ) => handleChange( e )}
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword( ( prev ) => !prev )}
                    className="absolute right-3 top-[34px] text-gray-500"
                    tabIndex={-1}
                    aria-label={showPassword ? "Hide password" : "Show password"}
                  >
                    {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                  </button>
                </div>
              </div>
              <div className="form-group mt-4 grid grid-cols-1 sm:grid-cols-2 gap-3">
                <div>
                  {isLoading ? <Loading /> :
                    <input
                      type="submit"
                      className="form-control bg-success"
                      id="btnSubmit"
                      name="btnSubmit"
                      value="SUBMIT"
                    />}
                </div>
                <div>
                  <input onClick={() => { navigate( "/staff", { replace: true } ) }}
                    type="button"
                    className="form-control"
                    value="Cancel"
                  />
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section></> )
}
export default StaffEditForm;